/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownLeftIcon24Solid = forwardRef('ArrowADownLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.121 18H16a1.5 1.5 0 0 1 0 3H6.5A3.5 3.5 0 0 1 3 17.5V8a1.5 1.5 0 1 1 3 0v7.879l11.94-11.94a1.5 1.5 0 0 1 2.12 2.122L8.122 18Z" })));
});
